"use client";

import { useEffect, useState } from "react";

export function useIsEditing() {
  const [isEditing, setIsEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const sync = () => {
      let inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch {
        inIframe = true;
      }

      const quickEditing = document.body.classList.contains("__tina-quick-editing-enabled");
      setIsEditing(inIframe || quickEditing);
      setIsOpen(quickEditing);
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return { isEditing, isOpen };
}
